import { SanitizedRichText } from "@/components/confluence/util/sanitized-rich-text";
import { Template } from "@/content/templates/template.types";

interface TemplateDescriptionSectionProps {
    template: Template;
}

export const TemplateDescriptionSection = ({
    template
}: TemplateDescriptionSectionProps) => {
    if (!template.aboutThisTemplate) {
        return null;
    }

    return (
        <section>
            <SanitizedRichText innerHTML={template.aboutThisTemplate} />
        </section>
    );
};
